export default {
  input: 'active overflow',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/labels.js